module.exports = __webpack_public_path__ + "img/034.fa8d885a.png";